<template>
  <nuxt-link
    v-if="isClient"
    :to="
      item
        | currentPermalink(
          $t(`router.product_permalink.type.${item.type}`),
          isOutlet,
          routeName
        )
    "
    class="container--box-card-custom-outlet-link"
    @click.native="handlerClick(item)"
  >
    <slot />
  </nuxt-link>
  <div v-else class="container--box-card-custom-outlet-link">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LadSearchExperiencesLink',
  filters: {
    currentPermalink(item, type, isOutlet, routeName) {
      const staticLinks = [
        '0d6898dd-7c38-46be-b3d0-df0599d6e560', // subir-ascenso-al-nevado-de-colima-en-un-dia-desde-guadalajara
        '40463dbc-f3bd-40d9-af4b-e3f7062956a6', // Ascenso-al-Nevado-de-Toluca
        '513aa3a1-d3fe-43b4-8b4d-24193d01f16c', // montanismo-el-Pico-de-Orizaba-desde-cdmx-8e33
        'c5d3a20c-844f-4122-8e8a-b86fa8310aeb', // Ascenso-volcan-iztaccihuatl-cdmx
      ]
      if (isOutlet && staticLinks.includes(item.uuid)) {
        routeName = 'product-permalink'
      }

      return {
        name: routeName,
        params: {
          type: routeName === 'product-permalink' ? type : item.type,
          permalink: item.permalink,
        },
      }
    },
  },
  props: {
    item: { type: Object, required: true, default: () => ({}) },
    routeName: { type: String, default: 'product-permalink' },
    isOutlet: { type: Boolean, default: false },
  },
  data() {
    return {
      base: 'components.experience',
      isClient: process.client,
    }
  },
  methods: {
    isProduct(item) {
      return ['experience', 'package'].includes(item.type)
    },
    handlerClick(item) {
      if (typeof this.$gtag !== 'undefined' && this.isProduct) {
        let price = item.total_amount

        if (item.promotions.length > 0) {
          const promotion = item.promotions[0]

          const isCurrentPromotion = Date.parse(promotion.end) >= Date.now()

          if (promotion.rules.length > 0) {
            price = promotion.rules[0].condition.includes(this.currency)
              ? item.total_amount * (1 - promotion.value / 100)
              : item.total_amount
          } else if (isCurrentPromotion) {
            price = item.total_amount * (1 - promotion.value / 100)
          }
        }

        this.$gtag('event', 'eec.productClick', {
          ecommerce: {
            click: {
              products: [
                {
                  name: item.title,
                  id: item.uuid,
                  price: price === 0 ? '' : price.toFixed(2).toString(),
                },
              ],
            },
          },
          eventCallback() {
            document.location = this.$route.fullPath
          },
          page_title: this.$metaInfo.title,
          page_location: window.location.href,
        })
      }
    },
  },
}
</script>
